import React, { useImperativeHandle, useState, forwardRef } from "react";
import { Form, Modal, Image, message, Input, Upload, Row, Col } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { request } from "../../../../utils/fetch";
import moment from "moment";
const MAX_IMAGE_COUNT = 4; // 最大上传数量

const ViewModal = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [type, setType] = useState("view");
  const [imgUrl, setImgUrl] = useState("");
  const [imgList, setImgList] = useState([]);

  useImperativeHandle(ref, () => ({
    show: (record) => {
      form.setFieldsValue({
        ...record,
        // relieveUrl 以逗号分隔的图片地址 转成数组

        relieveTime: record.relieveTime
          ? moment(record.relieveTime).format("YYYY-MM-DD HH:mm:ss")
          : "",
      });
      setType(record.type);
      setImgList(record.relieveUrl ? record.relieveUrl.split(",") : []);

      if (record.unbindImg) {
        const imgs = Array.isArray(record.unbindImg)
          ? record.unbindImg
          : [record.unbindImg];
        // 限制最多显示4张
        const limitedImgs = imgs.slice(0, MAX_IMAGE_COUNT);
        setFileList(
          limitedImgs.map((url, index) => ({
            uid: `-${index}`,
            name: `图片${index + 1}`,
            status: "done",
            url: url,
          }))
        );
      } else {
        setFileList([]);
      }

      setVisible(true);
    },
  }));

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
    setFileList([]);
  };

  // 确认时校验
  const handleOk = async () => {
    // 校验图片必传
    if (fileList.length === 0) {
      message.error("请上传解除图片");
      return;
    }
    try {
      const res = await request.post("/platform/staffRisk/update", {
        id: form.getFieldValue("id"),
        relieveUrl: imgUrl,
      });
      props.onSuccess();

      message.success("解除成功");
    } catch (error) {
      message.error(error.message);
    }

    // 校验是否有上传中的图片
    const hasUploading = fileList.some((f) => f.status === "uploading");
    if (hasUploading) {
      message.warning("图片正在上传中，请稍候");
      return;
    }

    setVisible(false);
  };

  const uploadProps = {
    accept: "image/*",
    multiple: true,
    action: "/wispay/common/uploadFile",
    listType: "picture-card",
    name: "files",
    fileList,
    data: {
      token: localStorage.getItem("token"),
      mobile: localStorage.getItem("mobile"),
    },
    onPreview: (file) => {
      console.log(file);
    },
    onChange: ({ fileList: newFileList }) => {
      console.log(newFileList);
      // 限制最多4张
      if (newFileList.length > MAX_IMAGE_COUNT) {
        message.error(`解除图片最多上传${MAX_IMAGE_COUNT}张`);
        setFileList(newFileList.slice(0, MAX_IMAGE_COUNT));
      } else {
        setFileList(newFileList);
      }
      const fileUrl = newFileList.map((item) => {
        if (item.response && item.response.success) {
          return item.response.data[0].url;
        }
      });
      setImgUrl(fileUrl.join(","));
    },
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>上传</div>
    </div>
  );

  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      title={type === "delete" ? "解除年龄控制" : "查看详情"}
      forceRender
      visible={visible}
      width={700}
      confirmLoading={uploading}
      onCancel={handleCancel}
      onOk={type === "delete" ? handleOk : handleCancel}
      okText="确认"
      cancelText="取消"
      maskClosable={false}
      bodyStyle={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "32px 0",
      }}
    >
      <div style={{ width: "100%", maxWidth: 600 }}>
        <Form form={form} layout="horizontal" labelAlign="left">
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="姓名" name="name" {...formItemLayout}>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="身份证号" name="idNumber" {...formItemLayout}>
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label="年龄" name="age" {...formItemLayout}>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="申请加入企业"
                name="companyName"
                {...formItemLayout}
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          {type === "view" && (
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="解除操作时间"
                  name="relieveTime"
                  {...formItemLayout}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="解除操作人"
                  name="relieveUser"
                  {...formItemLayout}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
          )}
          {(type === "delete" && (
            <Row>
              <Col span={24}>
                <Form.Item
                  label="解除图片"
                  name="unbindImg"
                  required
                  labelCol={{ span: 4, style: { textAlign: "left" } }}
                  wrapperCol={{ span: 20 }}
                  validateTrigger={["onChange", "onBlur"]}
                >
                  <Upload {...uploadProps}>
                    {/* 达到4张时不显示上传按钮 */}
                    {fileList.length >= MAX_IMAGE_COUNT ? null : uploadButton}
                  </Upload>
                </Form.Item>
                <div
                  style={{
                    color: "#999",
                    fontSize: 12,
                    marginLeft: "16.666%",
                    marginTop: -8,
                  }}
                >
                  支持上传多张图片，格式：jpg/png/gif，单张不超过5MB，最多
                  {MAX_IMAGE_COUNT}张
                </div>
              </Col>
            </Row>
          )) || (
            <Row>
              <Col span={24}>
                <Form.Item label="解除图片">
                  {imgList.map((url, index) => (
                    <Image
                      key={index}
                      width={100}
                      height={100}
                      src={url}
                      alt="relieve"
                      style={{ width: "100%", height: "auto" }}
                    />
                  ))}
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form>
      </div>
    </Modal>
  );
});

export default ViewModal;
